import React, { useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Input, Button, message } from 'antd';
import hospital2Image from '../../../images/hospital2.png';
import styles from '../../styles/accessCode.module.less';
import { utils } from '@ohif/core';
const { apiService } = utils;

function ShareAccessCode() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hidename = queryParams.get('hidename') === 'true';
  const registerKey = queryParams.get('register_key');
  const expirationDate = queryParams.get('expirationDate');
  const code = queryParams.get('code'); // 默认查看码
  const [messageApi, contextHolder] = message.useMessage();

  const [inputCode, setInputCode] = useState('');

  // 处理输入变化
  const handleCodeChange = useCallback(e => {
    setInputCode(e.target.value);
  }, []);

  // 验证查看码并跳转
  const handleVerifyOK = useCallback(() => {
    if (!inputCode) {
      messageApi.error('请输入查看码');
      return;
    }
    if (inputCode !== code) {
      messageApi.error('查看码错误');
      return;
    }
    if (!registerKey) {
      messageApi.error('缺少 register_key 参数，无法跳转');
      return;
    }

    apiService({
      uri: `/api/Share/Access?code=${code}`,
      method: 'GET',
      type: null,
    })
      .then(res => {
        if (res.message === '查看码无效或已过期。') {
          messageApi.error('查看码无效或已过期。');
          return;
        }
        const tokenManager = (window as any).tokenManager;
        if (tokenManager && tokenManager.setToken) {
          tokenManager.setToken(res.Token, res.TokenExpiresAt, res.RefreshToken);
        }
        const newParams = new URLSearchParams(location.search);
        newParams.set('flag', 'share');
        newParams.set('hidename', hidename.toString());
        navigate(`/sharereportdetail?${newParams.toString()}`);
      })
      .catch(res => {
        messageApi.error('验证失败，请稍后重试');
      });
  }, [inputCode, code, registerKey, location.search, navigate]);

  return (
    <>
    {contextHolder}
    <div className={styles.wrapper}>
      <div className={styles.accessCodeContainer}>
        <img
          src={hospital2Image}
          style={{ width: '40px', height: '40px' }}
          alt="医院图片"
          className={styles.hospitalImage}
        />
        <p className={styles.description}>
          为了保护数据信息安全，需要验证您的身份，请输入查看码进行校验。
        </p>
        <div>
          <Input
            maxLength={4}
            onChange={handleCodeChange}
            value={inputCode}
            className={styles.otpInput}
            placeholder="请输入4位查看码"
            autoFocus
          />
        </div>
        <p className={styles.tips}>将于{expirationDate}失效</p>
        <Button
          type="primary"
          onClick={handleVerifyOK}
          className="mt-[10px] h-[30px] w-[200px] bg-[#5794f7]"
        >
          确定
        </Button>
      </div>
    </div>
    </>
  );
}

export default ShareAccessCode;
